import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Incident } from "@/types/incidents";
import { AlertCard } from "@/components/alerts/AlertsPanel";
import { useNavigate } from "react-router-dom";
import { useSelectedAlert } from "@/context/SelectedAlertContext";
import { useIncidents } from "@/context/IncidentsContext";
import { useEffect, useState } from "react";
import { LoadingSpinner } from "@/components/ui/loading-spinner";

interface GroupInfoDialogProps {
  open: boolean;
  onClose: () => void;
  groupId: string;
}

export const GroupInfoDialog = ({
  open,
  onClose,
  groupId,
}: GroupInfoDialogProps) => {
  const navigate = useNavigate();
  const { setSelectedAlertId } = useSelectedAlert();
  const { incidents, isLoading } = useIncidents();
  const [groupAlerts, setGroupAlerts] = useState<Incident[]>([]);

  useEffect(() => {
    // Filter incidents that belong to this group
    const filteredAlerts = incidents.filter(
      (incident) => incident.grouped && incident.groupID === groupId
    );
    setGroupAlerts(filteredAlerts);
  }, [incidents, groupId]);

  const handleAlertClick = (alert: Incident) => {
    setSelectedAlertId(alert.incidentID);
  };

  const handleChatClick = (alert: Incident) => {
    setSelectedAlertId(alert.incidentID);
    navigate(`/alerts/chat/${alert.incidentID}`);
    onClose();
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-[450px] max-h-[80vh]">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold dark:text-gray-200">
            Group #{groupId}
          </DialogTitle>
        </DialogHeader>

        <div className="mt-4 pr-2 overflow-y-auto max-h-[60vh] space-y-4">
          {(() => {
            if (isLoading) {
              return (
                <div className="flex justify-center items-center h-32">
                  <LoadingSpinner size="medium" color="rgb(5 83 156)" />
                </div>
              );
            }
            if (groupAlerts.length === 0) {
              return (
                <div className="text-center text-gray-500 py-8">
                  No alerts found in this group
                </div>
              );
            }
            return groupAlerts
              .sort(
                (a, b) =>
                  new Date(b.reportedOn).getTime() -
                  new Date(a.reportedOn).getTime()
              )
              .map((alert) => (
                <AlertCard
                  key={alert.incidentID}
                  alert={alert}
                  isSelected={false}
                  onAlertClick={handleAlertClick}
                  onChatClick={handleChatClick}
                  hideMessageButton={true}
                  hideReportedTime={true}
                />
              ));
          })()}
        </div>
      </DialogContent>
    </Dialog>
  );
};
